
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';

import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { log } from 'console';

@Component({
  selector: 'app-exam-division-data',
  templateUrl: './exam-division-data.component.html',
  styleUrls: ['./exam-division-data.component.scss']
})
export class ExamDivisionDataComponent implements OnInit, AfterViewInit {
  ExamDivForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  ListTable = false;
  examdivList: any;
  list;
  autoserialnumber = 0;
  examdiv: string;
  ExamDivSearchForm;
  ExamDFormArray;
  examdivform: any;
  APIService: string;
  filteredListExId: any;
  isreadonlydel = false;
  filteredListDivision: any;
  EdDivlist: any;
  dialogRef: MatDialogRef<any>;
  codeTypeList: any;
  filteredCodeType: any;
  codeTypeThPrList: any;
  filteredCodeTypeThPr: any;
  BranchList: any;
  isShowBranch = false;
  ThPr = false;
  Grade = false;
  filteredListBranch: any;
  examdivList1: any;
  ExamName: any;
  examData: string;
  deleteButton: boolean;
  divisonArr = [];
  x = sessionStorage.getItem('EmId');
  CoCode = sessionStorage.getItem('EmCoCode');
  EmId: string;
  @Output() prev = new EventEmitter<void>();
  length = 0;
  lastData: any;
  dataLength: number;
  StrId: any;
  last: number;
  userPermission: any;
  ExDivCreate = true;
  ExDivUpdate = true;
  ExDivDelete = true;
  utp: any;
  constructor(public umsService: UmsService, private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl; }
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam-Division' && element.PCreate == false) {
          this.ExDivCreate = false;
        }
        // if(element.PageName == 'Course' && element.PUpdate == false)
        // {
        //     this.ExDivUpdate = false;  
        // }   
        if (element.PageName == 'Exam-Division' && element.PDelete == false) {
          this.ExDivDelete = false;
        }
      });
    }
    let id = '';
    this.submitButton = true;
    this.editButton = false;
    this.isreadonlydel = false;
    this.deleteButton = false;
    this.list = true;
    this.ExamDivForm = this.fb.group({
      EmName: new FormControl(sessionStorage.getItem('EmName')),
      EdEmId: new FormControl(sessionStorage.getItem('EmId'),),
      EdStrId: new FormControl('',),
      EdSrNo: new FormControl(this.autoserialnumber),
      EdEsThPr: new FormControl('',),
      EdEsId: new FormControl('',),
      EdDiv: new FormControl('', [Validators.required]),
      EdMarksPC: new FormControl('', [Validators.required, Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$')]),
      EdGrade: new FormControl('', [Validators.pattern("^[a-zA-z-+ &\\s]*$"), Validators.maxLength(4)]),
      EdMarksType: new FormControl(''),
    });
    this.fetchCodeType(id);
    this.fetchBranch(id);
    this.fetchCodeTypeThPr(id);
    this.getExamDivData(id);
    this.fetchExam(id);
    this.loadsettingspage();
    this.ExamDivSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });

    if (sessionStorage.getItem('EmElgblCd') == 'ThPr') {
      this.ThPr = true;
      this.Grade = true;
    } else {
      this.ThPr = false;
      this.Grade = false;
    }
    this.ExamDivForm.controls['EdMarksPC'].setValue('');
  }

  ngAfterViewInit(): void {
    let id = '';
    this.submitButton = true;
    this.editButton = false;
    this.isreadonlydel = false;
    this.deleteButton = false;
    this.list = true;
    this.autoserialnumber = 0;
    this.ExamDivForm = this.fb.group({
      EmName: new FormControl(sessionStorage.getItem('EmName')),
      EdEmId: new FormControl(sessionStorage.getItem('EmId'),),
      EdStrId: new FormControl('',),
      EdSrNo: new FormControl(this.autoserialnumber),
      EdEsThPr: new FormControl('',),
      EdEsId: new FormControl('',),
      EdDiv: new FormControl('', [Validators.required]),
      EdMarksPC: new FormControl('', [Validators.required, Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$')]),
      EdGrade: new FormControl('', [Validators.pattern("^[a-zA-z-+ &\\s]*$"), Validators.maxLength(4)]),
      EdMarksType: new FormControl(''),
    });
    this.fetchCodeType(id);
    this.fetchBranch(id);
    this.fetchCodeTypeThPr(id);
    this.getExamDivData(id);
    this.fetchExam(id);
    this.loadsettingspage();
    this.ExamDivSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });

    if (sessionStorage.getItem('EmElgblCd') == 'ThPr') {
      this.ThPr = true;
      this.Grade = true;
    } else {
      this.ThPr = false;
      this.Grade = false;
    }
  }

  keypress() {
    this.umsService.searchCollege(this.ExamDivSearchForm
      .value).subscribe(res => {
        this.examdivList = res.data;
      }, (ERROR: HttpErrorResponse) => {
        this.examdivList = [];
      });
  }

  download() {
    let wwe = ['EdSrNo', 'EdDiv', 'EdEsThPr', 'EdEsId', 'EdMarksPC', 'EdGrade']
    this.umsService.downloadFile(this.examdivList, 'jsontocsv', wwe);
  }

  getExamDivData(id) {
    this.divisonArr = [];
    const payload = {};
    payload['EdEmId'] = sessionStorage.getItem('EmId');
    payload['EdStrId'] = id;
    this.umsService.getExamDiv(payload).subscribe(res => {
      if (res.data.length > 0) {
        this.ListTable = true;
      }
      else {
        this.ListTable = false;
      }
      this.examdivList = res.data;
      this.length = res.data[0].EdStrId;
      this.dataLength = res.data.length;
      let last = this.dataLength - 1;
      this.lastData = res.data[last].EdMarksPC;
      res.data.forEach((e) => {
        this.divisonArr.push(e.EdDiv)
      })
      this.autoserialnumber = res.data.length;
      this.ExamDivForm.controls.EdSrNo.setValue(this.autoserialnumber);
    }, (ERROR: HttpErrorResponse) => {
      this.examdivList = [];
      this.lastData = 0;
    });
  }

  deletee(e, k, id) {
    if (e === 'true') {
      this.list = false;
      this.getExamDivData(id);
      this.prepopulationForDelete(k);
    } else {
      this.list = true;
    }
  }

  submit() {
    if (this.ExamDivForm.invalid) {
      this.ExamDivForm.get('EdEsThPr').markAsTouched();
      this.ExamDivForm.get('EdDiv').markAsTouched();
      this.ExamDivForm.get('EdMarksPC').markAsTouched();
      this.ExamDivForm.get('EdGrade').markAsTouched();
      return;
    } else {
      if ((this.ExamDivForm.value['EdStrId'] == "")) {
        this.ExamDivForm.controls['EdStrId'].setValue(0);
        this.createExamDiv();
        this.getExamDivData(this.ExamDivForm.value['EdStrId']);
      } else {
        this.createExamDiv();
        this.getExamDivData(this.ExamDivForm.value['EdStrId']);
      }
    }
  }

  createExamDiv() {
    this.spinner.show();
    this.submitpayload = this.ExamDivForm.value;
    this.umsService.addExamDiv(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngAfterViewInit();
          this.getExamDivData(this.ExamDivForm.value['EdStrId']);
        });
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Alert'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.ngAfterViewInit();
    });
  }

  prepopulationForDelete(id) {
    this.prepopulatedatapage(id);
    this.editButton = false;
    this.submitButton = false;
    this.isreadonlydel = true;
    this.deleteButton = true;
    this.ExamDivForm = this.fb.group({
      EmName: new FormControl(sessionStorage.getItem('EmName')),
      EdEmId: new FormControl(id.EdEmId),
      EdStrId: new FormControl(id.EdStrId),
      EdSrNo: new FormControl(id.EdSrNo),
      EdEsThPr: new FormControl(id.EdEsThPr),
      EdEsId: new FormControl(id.EdEsId),
      EdDiv: new FormControl(id.EdDiv, [Validators.required]),
      EdMarksPC: new FormControl(id.EdMarksPC, [Validators.required, Validators.pattern('^((100)|([0-9]{1,2}(.[0-9]*)?))$')]),
      EdGrade: new FormControl(id.EdGrade, [Validators.pattern("^[a-zA-z-+ &\\s]*$"), Validators.maxLength(4)]),
      EdMarksType: new FormControl(id.EdMarksType,)
    });
  }

  openConformationModalBox() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.deletedata(this.ExamDivForm.value);
      } else {
      }
    });
  }

  deletedata(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EdEmId: sessionStorage.getItem('EmId'),
        EdStrId: id.EdStrId,
        EdSrNo: id.EdSrNo,
        EdEsThPr: id.EdEsThPr,
        EdEsId: id.EdEsId,
        EdDiv: id.EdDiv,
        EdMarksPC: id.EdMarksPC,
        EdGrade: id.EdGrade,
        EdMarksType: id.EdMarksType,
      },
    };
    this.httpClient.delete(this.APIService + '/masters/exam-division', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngAfterViewInit();
        this.prev.emit();
        this.lastData = 0;
        this.autoserialnumber = 0;
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngAfterViewInit();
      });
    this.ExamDivForm.controls['EdMarksPC'].setValue('');
    this.ExamDivForm.controls['EdSrNo'].setValue(0);
  }

  addnewrecord(e) {
    if (e === 'true') {
      this.list = false;
      this.isreadonlydel = false;
      this.ExamDivForm.reset();
    } else {
      this.list = true;
    }

  }

  fetchDivision() {
    const payload = {};
    this.umsService.getExamDiv(payload).subscribe(res => {
      if (res.status) {
        this.EdDivlist = res.data;
        this.filteredListDivision = this.EdDivlist.slice();
      } else {
      }
    });
  }

  fetchCodeType(id) {
    const payload = {};
    payload['CdType'] = 'DD';
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.codeTypeList = res.data;
        this.filteredCodeType = this.codeTypeList.slice();
      } else {
      }
    })
  }

  fetchCodeTypeThPr(id) {
    const payload = {};
    payload['CdType'] = 'ThPr';
    payload['CdCode'] = id;
    this.umsService.getCode(payload).subscribe(res => {
      if (res.status) {
        this.codeTypeThPrList = res.data;
        this.filteredCodeTypeThPr = this.codeTypeThPrList.slice();
      } else {
      }
    })
  }

  fetchBranch(id) {
    const payload = {};
    payload['CoCode'] = sessionStorage.getItem('EmCoCode');;
    payload['EmId'] = sessionStorage.getItem('EmId');;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      } else {
      }
    })
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  back() {
    this.prev.emit();
  }

  fetchExam(data) {
    const payload = {};
    payload['EmCoCode'] = data;
    payload['EmId'] = data;
    this.umsService.getExam(payload).subscribe(res => {
      this.ExamName = sessionStorage.getItem('EmName');
      this.x = sessionStorage.getItem('EmId');
      this.ExamDivForm.controls['EmName'].setValue(this.ExamName);
      if (res.status) {
      } else {
      }
    })
  }

  getList(id) {
    this.isreadonlydel = false;
    this.StrId = id;
    this.ExamDivForm.controls['EdMarksPC'].setValue('');
    this.getExamDivData(id);
  }

  divisonClick(data) {
    this.divisonArr.forEach((e) => {
      if (data == e) {
        this.ExamDivForm.controls['EdDiv'].setValue('');
        let data = {}
        data['message'] = 'Division cannot be repeated'
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
      else {
      }
    });
  }

  valid() {
    let bar = new Promise<void>((resolve, reject) => {
      const payload = {};
      payload['EdEmId'] = sessionStorage.getItem('EmId');;
      if (this.StrId != "") {
        payload['EdStrId'] = this.StrId;
      }
      this.umsService.getExamDiv(payload).subscribe(res => {
        this.examdivList = res.data;
        this.dataLength = res.data.length;
        if (res.data.length > 0) {
          this.last = this.dataLength - 1;
          this.lastData = res.data[this.last].EdMarksPC;
        }
        else {
          this.lastData = 0;
        }
      });
      resolve();
    });
    bar.then(() => {
      if (this.dataLength == 0) {
        // this.ExamDivForm.controls['EdMarksPC'].setValue('');
      }
      else {
        if (this.ExamDivForm.value['EdMarksPC'] >= this.lastData && this.lastData !== 0) {
          this.ExamDivForm.controls['EdMarksPC'].setValue('');
          let data = {}
          data['message'] = 'Marks should be less than latest marks'
          data['title'] = 'Alert'
          data['icon'] = 'fas fa-close'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      }
    });
  }
  prepopulatedatapage(e) {
    let payload = {};
    payload['FormPage'] = 'DivisionBranch';
    // this.ExamForm.controls['StuId'].setValue(e.data[0]['StuId']);
    this.umsService.getStdSetting(payload).subscribe((ress) => {
      ress.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.ExamDivForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], Validators.required));
            }
            else {
              this.ExamDivForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName], [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.ExamDivForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
          }
        } else {
          this.ExamDivForm.addControl(element.FormControlName, new FormControl(e.data[0][element.FormControlName]));
        }
      });
      this.mapdataaa(ress.data);
    });
  }

  loadsettingspage() {
    let payload = {};
    payload['FormPage'] = 'DivisionBranch';
    this.umsService.getStdSetting(payload).subscribe((res) => {
      res.data.forEach((element) => {
        if (element.FormVisible) {
          if (element.FormRequired) {
            if (element.FormPattern == '') {
              this.ExamDivForm.addControl(element.FormControlName, new FormControl('', Validators.required));
            }
            else {
              this.ExamDivForm.addControl(element.FormControlName, new FormControl('', [Validators.required, Validators.pattern(element.FormPattern)]));
            }
          } else {
            this.ExamDivForm.addControl(element.FormControlName, new FormControl(''));
          }
        }
      });
      this.mapdataaa(res.data);
    });
  }
  
  mapdataaa(e) {
    this.ExamDFormArray = e.reduce(function (r, a) {
      r[a.FormControlName] = r[a.FormControlName] || [];
      r[a.FormControlName].push(a);
      return r;
    }, Object.create(null));
  }
}
